import Box from '@app/components/common/Box';
import Divider from '@app/components/common/Divider';
import { displayFlexColumnStyles } from '@app/theme/commonStyles';
import { formatMoney } from '@westondev/tableturn-core';
import { useContext } from 'react';
import { WithTranslation } from 'react-i18next';
import { EmployeesScreenContext } from '../../EmployeesContext';
import AmountHeader from './AmountHeader';
import AmountRow from './AmountRow';
import AmountTotals from './AmountTotals';
import { AmountsStyles } from './styles';

const Amounts = ({ t }: WithTranslation) => {
  const { employeeSummary } = useContext(EmployeesScreenContext);
  return (
    <Box className="card">
      <Box csx={AmountsStyles}>
        <AmountHeader
          data={[
            t('menuScreen.common.settings.roles.singular'),
            t(
              'managementModule.employeesScreen.employeeDetailsTable.hoursWorked',
            ),
            t('managementModule.employeesScreen.employeesTable.sales'),
            t('managementModule.employeesScreen.employeesTable.tipsEarned'),
          ]}
        />
        <Divider />
        <AmountTotals />
        <Divider />
        <Box
          csx={[
            displayFlexColumnStyles,
            { flexGrow: 1, flexShrink: 1, height: 0, overflowY: 'auto' },
          ]}>
          {(employeeSummary?.employeeSummary || []).map((summary, index) => (
            <AmountRow
              key={`amount-row-${index}`}
              data={[
                summary.role,
                summary.hoursWorked.toFixed(2),
                formatMoney(null, summary.sales),
                formatMoney(null, summary.tipsEarned),
              ]}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default Amounts;
